import { graphql } from 'react-relay';

export const gqlPoshmarkCatalog = graphql`
  query poshmarkCatalogQuery {
    superposherPoshmarkCatalog {
      sourceUrl
    }
  }
`;
